import NoSearchResult from "../../../orders/NoSearchResult";
import UserListRow from "./UserListRow";

interface IUserManagementProps {
  users: any[];
  columns: any[];
  emptyListTitle: string;
  emptyListInfo?: string;
}

const UserList = ({
  users,
  columns,
  emptyListTitle,
  emptyListInfo,
}: IUserManagementProps) => {
  return users.length > 0 ? (
      <div>
        {
          users.map((user: any) => (
            <UserListRow user={user} columns={columns} />
          ))
        }
      </div>
  ) : (
    <NoSearchResult title={emptyListTitle} info={emptyListInfo} />
  );
};

export default UserList;
